import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import styles from '../../home-page/HomePage.module.scss';
import { ratesActions } from '../../../stores/_actions';
import Label from '../../../constants/Label';
import { Pagination } from 'semantic-ui-react';
import { NoRecord } from '../norecord/norecord';
import { Heading } from './Heading';
import { ListItems } from './ListItems';

function Rates(props) {
  const location = useLocation();
  let customerCode;
  const jsonData = localStorage.getItem('customer');
  const customer = JSON.parse(jsonData);

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: null,
    Data: {
      ServNo: '',
      CustomerCode: customerCode,
      AmountType: '',
      Amount: '',
      RcvCurrency: '',
    },
    Status: false,
    SessionID: '',
    IdType: null,
  };
  const dispatch = useDispatch();
  let style = styles.width49;
  style = location.pathname == '/home' ? styles.width49 : styles.width100;
  style = location.pathname == '/calculator' ? styles.width49 : style;

  useEffect(() => {
    dispatch(ratesActions.getRates(payload));
    dispatch(ratesActions.clearRatesData());
  }, []);

  let rates;
  let status;
  let currencies;
  let data;
  useSelector((state) => {
    rates = state.getRate.data;
    status = state.getRate.getrates;
    currencies = state.currency?.data;
  }, []);
  if (currencies && rates) {
    data = [...rates];
    rates.forEach((ele, index) => {
      const data1 = currencies.filter((cur) => cur.ID === ele.CurCode);
      data[index]['ID'] = data1[0].Description;
    });
    rates = [...data];
  }
  const count = location.pathname == '/calculator' ? 10 : location.pathname == '/rates' ? 13 : 4;

  const [pager, setPage] = useState({
    page: 1,
    itemsPerPage: count,
  });
  // let items = createItems(100);
  const setPageNum = (event, { activePage }) => {
    setPage({ page: activePage });
  };
  const itemsPerPage = count;
  const { page } = pager;
  const totalPages = Math.ceil(rates && rates.length / itemsPerPage);
  const items = rates && rates.slice((page - 1) * itemsPerPage, (page - 1) * itemsPerPage + itemsPerPage);

  return (
    <div className={styles.pageLeft__rates + ` ` + style}>
      <h2>
        {Label.Rates.heading} {location.pathname == '/home' ? <Link to="/rates">View All</Link> : ''}
      </h2>

      <div className={styles.divTable}>
        <Heading styles={styles} />
        {rates ? <ListItems list={items} styles={styles} /> : <NoRecord status={status} />}
        {location.pathname == '/rates' && rates ? (
          <div className={styles.pageCount}>
            <div className={styles.pageCountcont}>
              <span>{page}</span> / <span>{totalPages}</span>
            </div>
            <div className={styles.carousal}>
              <Pagination
                boundaryRange={0}
                defaultActivePage={page}
                ellipsisItem={null}
                firstItem={null}
                lastItem={null}
                siblingRange={null}
                totalPages={totalPages}
                onPageChange={setPageNum}
              />
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export { Rates };
